import { isAfter } from 'date-fns'

import { formatDate } from '@/utils/date'
import type { TimeInterval } from '@/utils/dateRange'

import type { DataPoint } from './types'

export const toXAxisLabel = (date: Date, timeInterval: TimeInterval) =>
  timeInterval === 'hour' ? formatDate(date, 'HH:00') : formatDate(date, 'dd MMM')

export const sortDataPoints = (a: DataPoint, b: DataPoint) =>
  isAfter(a.date, b.date) ? 1 : -1
